import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { AppRoutes } from '@app/app.routes';

export const routerProviders = provideRouter(
  AppRoutes,
  withRouterConfig({ paramsInheritanceStrategy: 'always', }),
  withInMemoryScrolling({ scrollPositionRestoration: 'top' })
);